import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor ( 
    private auth: AuthService,
    private router: Router ) {
    
  }

  canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): boolean {

    // console.log('GUARD ' + route.pathFromRoot[1]);
    console.log(route.pathFromRoot.join('-'))
    let element = route.pathFromRoot[route.pathFromRoot.length-1].url.toString();
    if (element.indexOf(',')) {
      console.log(element)
      element = element.substring(element.indexOf(',')+1, element.length);
      console.log(element)
    }
    if ( this.auth.estaAutenticat() && this.auth.perfilAutoritzat(element)) {
      // console.log("AUTORITZAT");
      return true;
    } else {
      // console.log("NO AUTORITZAT");
      this.router.navigateByUrl('auth/login');
      return false;
    }
  }
  
}
